import { SelectField } from '@namespace/forms';
import { mapListToOptions } from '../../utils/mapListToOptions';

const SELECT_TYPES = {
  SELECT: 'select',
  WITH_INPUT: 'with_input',
  SEARCH_SELECT: 'search_select'
};

export const Regions = ({ regions, ...props }) => {
  const options = mapListToOptions(regions, 'region');

  return (
    <SelectField
      {...props}
      options={options}
      selectType={SELECT_TYPES.SEARCH_SELECT}
      noResetFormData={true}
      arrowSize="xs"
      hasSearch={true}
      disableInputAutoClean={true}
    />
  );
};
